import React, {useState} from "react";
import {Button, Header, Message} from "semantic-ui-react";
import {PaymentDetails} from "./PaymentDetailsContainer";
import CreditCardPm from "./creditCardPm";
import PaymentMethodSelected from "./paymentMethodSelected";
import YourCosts from "./yourCosts";
import Plaid from "./plaid";
import {S3Image, CustomGrid, ClickableText} from "../custom-common";
import IMAGE from "../../constants/images";
import {
    addBankAccount,
    addMicroDeposits,
    getPrepareReview,
    removeBankAccountService,
    removeMicroDepositsBankAccountService
} from "../../services/services";
import {
    AddMicroDepositsOrBankAccountRequest,
    PrepareReviewRequest, RemoveBankAccountRequest,
    RemoveMicroDepositsBankAccountRequest
} from "../../services/types";

const PaymentDetailsCard = (props) => {
    const {
        creditCardPmVisibility,
        showCreditCardPm,
        isPmSelected,
        showPaperCheckInstrucions,
        setPlaidData,
        setMicroDepositsPlaidData,
        showPaymentDetailsCardLoading,
        isBankAccountPmSelected,
        isMicroDepositsAccountSelected,
        setStripePaymentError,
        addPaymentMethodError,
        setAddPaymentMethodError,
    } = PaymentDetails.useContainer()

    const {
        plaidEnviroment,
        stripePublicKey,
        formattedCostPayment,
        user,
        token,
        paymentDetails,
        accountSfId,
        strings,
    } = props;

    const [plaidLinkToken] = useState(props.plaidLinkToken)

    const handleSetPlaidData = async (data) => {
        const {public_token, account_id, metadata} = data
        const payload = new AddMicroDepositsOrBankAccountRequest({
            publicToken: public_token,
            accountId: account_id,
            email: user.email,
            firstName: user.firstName,
            lastName: user.lastName,
            metadata,
            token,
            accountSfId: accountSfId,
        });
        if (data.account.verification_status === "pending_manual_verification") {
            await addMicroDepositsBankAccount(payload)
        } else {
            await addBankAccountWithAuth(payload)
        }
    }

    const addBankAccountWithAuth = async (payload) => {
        showPaymentDetailsCardLoading(true)
        try {
            const response = await addBankAccount(payload)
            setPlaidData(response.data)
            showPaymentDetailsCardLoading(false)
        } catch (err) {
            console.log(err);
            showPaymentDetailsCardLoading(false)
            setAddPaymentMethodError(strings.addBankAccountError)
        }
    }

    const addMicroDepositsBankAccount = async (payload) => {
        const getBillingInfoPayload = new PrepareReviewRequest({ token })
        try {
            showPaymentDetailsCardLoading(true)
            await addMicroDeposits(payload)
            const getBillingInfoResponse = await getPrepareReview(getBillingInfoPayload)
            setMicroDepositsPlaidData(getBillingInfoResponse.microDepositsBankAccount)
            showPaymentDetailsCardLoading(false)
        } catch (err) {
            showPaymentDetailsCardLoading(false)
            setAddPaymentMethodError(strings.addBankAccountError)
        }
    }

    const removeBankAccount = async (id) => {
        const payload = new RemoveBankAccountRequest({
            paymentMethodId: id,
            email: user.email,
            token,
            accountId: accountSfId,
        });
        try {
            showPaymentDetailsCardLoading(true)
            await removeBankAccountService(payload)
            showPaymentDetailsCardLoading(false)
        } catch (e) {
            showPaymentDetailsCardLoading(false)
        }
        setStripePaymentError(null);
    }

    const removeMicroDepositsBankAccount = async (accountId) => {
        const payload = new RemoveMicroDepositsBankAccountRequest( {
            accountId,
        })
        try {
            showPaymentDetailsCardLoading(true)
            await removeMicroDepositsBankAccountService(payload)
            showPaymentDetailsCardLoading(false)
        } catch (e) {
            showPaymentDetailsCardLoading(false)
        }
        setStripePaymentError(null);
    }

    const YourCost = <YourCosts cost={user.cost}
                                employerContribution={user.employerContribution}
                                formattedCostPayment={formattedCostPayment}
                                strings={strings} />

    const YourCostWithBorder = <CustomGrid.Row style={{borderTop: "1px dashed lightgray", paddingTop: "25px", marginTop: "5px"}}>
        { YourCost }
    </CustomGrid.Row>

    const noPaymentMethodSelected =
        <CustomGrid container>
            <CustomGrid.Row columns={2} style={{alignItems: "center", margin: "1em 0"}}>
                <S3Image {...IMAGE.PAYMENT_METHOD}/>
                <CustomGrid.Column textAlign={"left"} width={10}>
                    <CustomGrid.Row centered textAlign={"center"}>
                        <p style={{fontSize:"14px"}}>{strings.youHaveNoEPayment}</p>
                        <Plaid plaidEnviroment={plaidEnviroment}
                               plaidLinkToken={plaidLinkToken}
                               setPlaidData={handleSetPlaidData}
                               strings={strings}/>
                        <strong style={{margin:"0 15px 0 15px"}}>{strings.or}</strong>
                        <Button style={{minWidth:"170px", fontWeight:"700"}} primary basic
                                onClick={showCreditCardPm}>{strings.addCreditCard}</Button>
                    </CustomGrid.Row>
                </CustomGrid.Column>
            </CustomGrid.Row>
            <CustomGrid.Row style={{borderTop: "1px dashed lightgray", margin:"0px"}}>
                <CustomGrid.Column width={6}>
                    { YourCost }
                </CustomGrid.Column>
            </CustomGrid.Row>
            <CustomGrid.Row>
                <p style={{ fontSize: '12px', lineHeight: '1.2' }}>{strings.iDontWantToMake}
                    <ClickableText onClick={showPaperCheckInstrucions} className={'smaller'}> {strings.seeInstructions}</ClickableText>
                </p>
            </CustomGrid.Row>
        </CustomGrid>;

    return (
        <>
            { addPaymentMethodError && <Message negative> {addPaymentMethodError}</Message> }
            <CustomGrid stackable container>
                <CustomGrid.Row>
                    <CustomGrid.Column textAlign={"left"} className={'neutral700Text small'}>
                        <Header as="h2">{strings.paymentsDetails}</Header>
                        <p>{strings.pleaseAddYour}</p>
                        <p>
                            {strings.byEnteringPayments}
                        </p>
                        <p>
                            {strings.yourInformationWill}
                        </p>
                    </CustomGrid.Column>
                </CustomGrid.Row>
                { !creditCardPmVisibility && !isPmSelected && noPaymentMethodSelected }
                { creditCardPmVisibility &&
                    <CreditCardPm stripePublicKey={stripePublicKey}
                                  strings={strings}
                                  YourCost={YourCostWithBorder}
                    />
                }
                { (isBankAccountPmSelected() || isMicroDepositsAccountSelected()) &&
                    <PaymentMethodSelected
                        YourCost={YourCostWithBorder}
                        removeBankAccount={removeBankAccount}
                        removeMicroDepositsBankAccount={removeMicroDepositsBankAccount}
                        paymentDetails={paymentDetails}
                        strings={strings}
                        setPlaidData={handleSetPlaidData}
                    />
                }
            </CustomGrid>
        </>
    )
}

export default PaymentDetailsCard;